jQuery(document).ready(function($) {
		
	jQuery('#home-slider').slick({
		autoplay: true,
		autoplaySpeed: 9000,
		fade: true,
		arrows: false,
		dots: true,
		dotsClass: 'home-slider-dots',
		responsive: [
			    {
			      breakpoint: 1023,
			      settings: {
			      dots: false,
			      }
			    }
			]
  	});

  	jQuery('#insta-slider').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		speed: 300,
		prevArrow: '<button type="button" class="slick-prev"><i class="icon-left-open-mini"></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="icon-right-open-mini"></button>',
		slidesPerRow: 4,
			responsive: [
			    {
			      breakpoint: 1201,
			      settings: {
			        slidesToShow: 4,
			        slidesToScroll: 1,
			      }
			    },
			    {
			      breakpoint: 1200,
			      settings: {
			        slidesToShow: 3,
			        slidesToScroll: 1,
			      }
			    },
			    {
			      breakpoint: 1023,
			      settings: {
			        slidesToShow: 2,
			        slidesToScroll: 2,
			      }
			    },
			    {
			      breakpoint: 750,
			      settings: {
			        slidesToShow: 1,
			        slidesToScroll: 1,
			      }
			    }
			]
  	});
}); /* end of as page load scripts */